export enum ClaimantInformationFormNamesEnum {
  FORM_GROUP_NAME = 'ClaimantInformation',
  MATCH = 'Match',
  CLEAR = 'Clear',
  DO_NOT_MATCH_IND = 'doNotMatchInd',
  MATCHED = 'matched',
}
